<!--recycle-bin:单科考试 - 回收站 2023/12/18 14:21:09 YuAng-->
<template>
  <div class="recycle-bin">
    <div class="top">
      <el-tabs v-model="examType" @tab-click="handleCurrentChange(1)">
        <el-tab-pane label="校内考试" name="1"></el-tab-pane>
        <el-tab-pane label="省区联考" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="wrapper">
      <div class="main" v-loading="page.loading">
        <p class="back-recycle" @click="$router.back()">
          <span class="el-icon-arrow-left"></span>
          <span>返回 | 回收站</span>
        </p>
        <div style="background-color: white;padding: 10px 20px;">
          <el-table :data="list">
            <el-table-column prop="id" label="考试ID" width="200"></el-table-column>
            <el-table-column prop="subjectExamName" label="学科" width="100"></el-table-column>
            <el-table-column prop="examName" label="考试名称" align="center"></el-table-column>
            <el-table-column width="150" align="center" label="删除时间">
              <template slot-scope="scope">
                {{ scope.row.updateTime | formatDate }}
              </template>
            </el-table-column>
            <el-table-column width="100" align="center" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="recoverItem(scope.row)">恢复</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <zj-pagination @current-change="handleCurrentChange" :page="page"></zj-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { examApi } from '@/utils/api'
import util from '@/v2/utils/util'
import ZjPagination from '@/pages/zujuan/components/ZjPagination.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'RecycleBin',
  components: { ZjPagination },
  data () {
    return {
      examType: 'SCHOOL',
      list: [],
      page: {
        current: 1,
        size: 20,
        total: 0,
        loading: false
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    })
  },
  created () {
    const type = this.$route.query.examType
    if (type) {
      this.examType = type
    }
    this.loadData()
  },
  methods: {
    loadData () {
      this.page.loading = true
      const params = {
        schoolId: this.userInfo.schoolId, // 学校id
        isMore: this.examType + '' == '1' ? ['SCHOOL'] : ['MULIT_SCHOOLS', 'REGION'],
        currentPage: this.page.current, // 页码
        pageSize: this.page.size, // 每页条数
      }
      examApi.recycleExamList(params).then(resp => {
        if (resp.body) {
          for (let index = 0; index < resp.body.items.length; index++) {
            const item = resp.body.items[index];
            item.subjectExamName = util.subjectExamName(item)
          }
          this.list = resp.body.items
          this.page.total = resp.body.totalSize
        } else {
          this.list = []
          this.page.total = 0
        }
      }).finally(() => {
        this.page.loading = false
      })
    },
    handleCurrentChange (page = 1) {
      this.page.current = page
      this.loadData()
    },
    async recoverItem (item) {
      try {
        const message = '是否确认恢复【' + item.examName + '】考试？'
        await this.$confirm(message, '提示');
        const resp = await examApi.recoverExam(item.id)
        if (resp.body) {
          this.handleCurrentChange()
          this.$message.success('恢复成功')
        } else {
          this.$message.error(`操作失败，${resp.message}`)
        }
      } catch (error) { }
    }
  },
  filters: {
    formatDate (time) {
      return util.formatDate(time, 'ymd')
    }
  }
}
</script>
<style scoped lang="scss">
.top {
  height: 40px;
  background: white;
  position: fixed;
  top: 54px;
  z-index: 1000;
  left: 0;
  right: 0;
  padding: 0 20px;
}

.back-recycle {
  color: #747474;
  padding: 10px 0;
  font-size: 12px;
  cursor: pointer;
  display: inline-block;
}

.recycle-bin {
  padding-top: 20px;
}

.top ::v-deep .el-tabs__nav-wrap::after {
  background: transparent;
}

.wrapper {
  margin: 0 20px;
}

.main {
  min-height: calc(100vh - 290px);

  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    min-height: calc(100vh - 290px);
    background: #fff;

    p {
      color: #999;
      line-height: 30px;
    }
  }

  .pagination {
    text-align: right;
    padding: 10px 0 20px;

    .el-pagination {
      padding-right: 0;
    }
  }
}
</style>
<style lang="scss">
.recycle-bin_route .container {
  width: 100% !important;
  margin: auto !important;
}
</style>